<div class="main-section">
    <p [innerHTML]="txtContant"></p>
    <div class="button-wrapper">
        <button type="button" class="btn--transparent" (click)="bottomSheetClose()">No</button>
        <button type="button" class="btn--primary" (click)="documentUploadBottomSheet()">Yes</button>
    </div>
</div>
@if(btnLoader){
    <div class="bottom-button-wrapper btn" >
        <button class="btn btn--primary">
            <span class="stage">
                <span class="dot-pulse"></span>
            </span>
        </button>
    </div>
}
